/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
/**
 * ArvanLiveApi - axios parameter creator
 * @export
 */
export const ArvanLiveApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} id My Live Stream Id Value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    arvanCloudLiveControllerGetAnalytics: async (
      pageNumber: number,
      pageIndex: number,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling arvanCloudLiveControllerGetAnalytics."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling arvanCloudLiveControllerGetAnalytics."
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          "id",
          "Required parameter id was null or undefined when calling arvanCloudLiveControllerGetAnalytics."
        );
      }
      const localVarPath = `/v1/cms/api/live/stream-external`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ArvanLiveApi - functional programming interface
 * @export
 */
export const ArvanLiveApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} id My Live Stream Id Value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async arvanCloudLiveControllerGetAnalytics(
      pageNumber: number,
      pageIndex: number,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ArvanLiveApiAxiosParamCreator(
        configuration
      ).arvanCloudLiveControllerGetAnalytics(
        pageNumber,
        pageIndex,
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ArvanLiveApi - factory interface
 * @export
 */
export const ArvanLiveApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} id My Live Stream Id Value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async arvanCloudLiveControllerGetAnalytics(
      pageNumber: number,
      pageIndex: number,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ArvanLiveApiFp(configuration)
        .arvanCloudLiveControllerGetAnalytics(
          pageNumber,
          pageIndex,
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ArvanLiveApi - object-oriented interface
 * @export
 * @class ArvanLiveApi
 * @extends {BaseAPI}
 */
export class ArvanLiveApi extends BaseAPI {
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} id My Live Stream Id Value
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ArvanLiveApi
   */
  public async arvanCloudLiveControllerGetAnalytics(
    pageNumber: number,
    pageIndex: number,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ArvanLiveApiFp(this.configuration)
      .arvanCloudLiveControllerGetAnalytics(pageNumber, pageIndex, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
